export const sv = {
  title: 'Tjänster',
  subtitleCarCare: 'Hantera dina bilvårdstjänster',
  subtitleGarage: 'Hantera dina garagets tjänster',
  addService: 'Lägg till tjänst',
  statTotal: 'Totalt',
  statActive: 'Aktiva',
  statInactive: 'Inaktiva',
  category: 'Kategori',
  allCategories: 'Alla kategorier',
  emptyTitle: 'Inga tjänster hittades',
  emptyFiltered: 'Prova att välja en annan kategori',
  emptyDefault: 'Börja med att lägga till din första tjänst',
  price: 'Pris',
  askUs: 'Fråga oss',
  duration: 'Tid',
  edit: 'Redigera',
  editService: 'Redigera tjänst',
  cancel: 'Avbryt',
  saveChanges: 'Spara ändringar',
  createService: 'Skapa tjänst',
  imageLabel: 'Bild',
  uploadPrompt: 'Klicka för att ladda upp bild',
  uploadHint: 'PNG, JPG upp till 5MB',
  nameLabel: 'Namn *',
  namePlaceholder: 't.ex. Oljebyte',
  descriptionLabel: 'Beskrivning',
  descriptionPlaceholder: 'Beskriv tjänsten...',
  priceLabel: 'Pris ({currency})',
  pricePlaceholder: 't.ex. 1250',
  durationLabel: 'Tidsåtgång (minuter)',
  durationPlaceholder: 't.ex. 60',
  activeToggle: 'Tjänsten är aktiv och synlig för kunder',
}

export const en: typeof sv = {
  title: 'Services',
  subtitleCarCare: 'Manage your car care services',
  subtitleGarage: 'Manage your garage services',
  addService: 'Add service',
  statTotal: 'Total',
  statActive: 'Active',
  statInactive: 'Inactive',
  category: 'Category',
  allCategories: 'All categories',
  emptyTitle: 'No services found',
  emptyFiltered: 'Try selecting another category',
  emptyDefault: 'Start by adding your first service',
  price: 'Price',
  askUs: 'Ask us',
  duration: 'Duration',
  edit: 'Edit',
  editService: 'Edit service',
  cancel: 'Cancel',
  saveChanges: 'Save changes',
  createService: 'Create service',
  imageLabel: 'Image',
  uploadPrompt: 'Click to upload an image',
  uploadHint: 'PNG, JPG up to 5MB',
  nameLabel: 'Name *',
  namePlaceholder: 'e.g. Oil change',
  descriptionLabel: 'Description',
  descriptionPlaceholder: 'Describe the service...',
  priceLabel: 'Price ({currency})',
  pricePlaceholder: 'e.g. 1250',
  durationLabel: 'Duration (minutes)',
  durationPlaceholder: 'e.g. 60',
  activeToggle: 'The service is active and visible to customers',
}
